export const UnitTypes = {
    metric: {
        kg_ha: "kg/ha",
        m: "m",
        meters: "meters",
        Lph: "Lph",
        kg: "kg",
        L: "L",
        L_ha: "L/ha",
        mm: "mm",
        C: "°C",
        km_h: "km/h",
        ha: "ha",
        cm: "cm",
    },
    imperial: {
        bushels_per_acre: "bu/ac",
        lb_ac: "lb/ac",
        ft: "ft",
        mph: "mph",
        gph: "gph",
        lbs: "lbs",
        gals: "gals",
        gal_ac: "gal/ac",
        lbs_ac: "lbs/acre",
        in: "in",
        F: "°F",
        ac: "ac",
    },
};
